import Request from './request'

const Auth = {
  getUserPermissions (callback) {
    Request.get('auth/permissions').then(callback).catch(this.bad_answer)
  },
  getUserStatus (callback, bad_answer) {
    Request.get('auth/status').then(callback).catch(bad_answer)
  },
  logoutUser (callback) {
    Request.get('auth/logout').then(callback).catch(this.bad_answer)
  },
  loginUser (params, callback, bad_answer) {
    if (!params) {
      params = {}
    }
    Request.post('auth/login', JSON.stringify(params)).then(callback).catch(bad_answer)
  },
}
export default Auth
